import React from "react";
import { useTranslation } from "react-i18next";

export interface MessageGo2LinkProps {
  link: string;
  linkText: string;
}

export const MessageGo2Link = (props: React.PropsWithChildren<MessageGo2LinkProps>) => {
  const { link, linkText, children } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center">
      <div>{typeof children === "string" ? t(children) : children}</div>
      <a href={link} target="_blank" rel="noopener noreferrer">
        {t(linkText)}
      </a>
    </div>
  );
};
